// extracted by mini-css-extract-plugin
export default {"loading-container":"WebAppLoading_loading-container__Ezd3q","lds-ripple":"WebAppLoading_lds-ripple__Oy1d9"};